// auth.js
export const getAuth = () => JSON.parse(localStorage.getItem("user"));
export const isAuthenticated = () => !!getAuth();
export const getRole = () => getAuth()?.role || "";
